import NewTable from "components/NewTable";
import useListagemContatoUnidadeColumns from "./hooks/useListagemContatoUnidadeColumns";
import { PessoaContato } from "features/unidades/typings/unidade";

function TabelaContato({
  isLoading,
  data,
  containerRef,
  onEdit,
  onDelete,
  hideShadow,
}: {
  data: PessoaContato[];
  isLoading: boolean;
  containerRef?: React.RefObject<HTMLElement | null> | undefined;
  onEdit?: (index: number) => any;
  onDelete?: (index: number) => any;
  hideShadow?: boolean;
}) {
  const columns = useListagemContatoUnidadeColumns();

  return (
    <NewTable<PessoaContato>
      // styles={{ boxShadow: "none", color: colors.black, fontWeight: 700, textAlign: "start", maxWidth: 260, padding: "0px 0px 16px 0" }}
      loading={isLoading}
      columns={[...columns]}
      dataSource={data}
      size="small"
      hideShadow={hideShadow}
      actionsContainerRef={containerRef}
      actions={[
        {
          title: "Editar",
          onClick: (_, index) => {
            if (Number.isInteger(index)) {
              onEdit?.(index!);
            }
          },
        },
        {
          title: "Excluir",
          onClick: (_, index) => {
            if (Number.isInteger(index)) {
              onDelete?.(index!);
            }
          },
        },
      ]}
    />
  );
}

export default TabelaContato;
